import styled from 'styled-components';

export const ContainerFluid = styled.div`
  width: 100%;
  padding: 24px;
  background-color: #f4f4f4;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
  @media (max-width: 400px) {
    justify-content: center;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  @media (max-width: 1000px) {
    gap: 20px;
    flex-direction: column;
  }
`;

export const SocialMediaInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Image = styled.img``;

export const TextWrapper = styled.div`
  @media (max-width: 1000px) {
    text-align: center;
  }
`;

export const Text = styled.p`
  font-size: 12px;
  color: #414040;
  line-height: 16.34px;
  font-weight: 400;
`;

export const IconWrapper = styled.div`
  gap: 20px;

  @media (max-width: 1000px) {
    display: flex;
    width: 100%;
    justify-content: center;
  }
`;
